import React, { useState } from "react";
import {
  BookingCancellations,
  UsersLeft,
  UsersReached,
  bookingIcon,
  FilterIconBlack,
  totalBookings,
  AdminFilterIconBlack,
} from "../../../constant/imagePath";
import { AdminTable } from "../../../stories/AdminTable/AdminTable";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { Button } from "../../../stories/Button/Button";
import UsaMapCharts from "../../../stories/UsaMapCharts/UsaMapCharts";
import ReactTooltip from "react-tooltip";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { Line } from "rc-progress";

import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import classes from "./AdminDashboard.module.css";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { Container, Row, Col } from "react-bootstrap";
import UnBanModal from "../../../components/Modals/Admin/UnBanModal/UnBanModal";
import BanExplanationModal from "../../../components/Modals/Admin/BanExplanationModal/BanExplanationModal";
import UserDetailModal from "../../../components/Modals/Admin/UserDetailModal/UserDetailModal";
import MessageDetailsModal from "../../../components/Modals/Admin/MessageDetailsModal/MessageDetailsModal";

import { ReactSVG } from "react-svg";
import { Radio } from "../../../stories/Radio/Radio";
import { AverageAgeRangePicker } from "../../../stories/AverageAgeRangePicker/AverageAgeRangePicker";
import SaveFilterModal from "../../../components/Modals/Admin/SaveFilterModal/SaveFilterModal";
import Layout from "../Layout/Layout";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Checkbox } from "../../../stories/Checkbox/Checkbox";
import { SearchWithList } from "../../../stories/SearchWithList/SearchWithList";
import PopupRenderer from "../../../stories/PopupRenderer/PopupRenderer";
import { SavedFilters } from "../../../stories/SavedFilters/SavedFilters";

const AdminDashboard = () => {
  const [bookings, setBookings] = useState();
  const [content, setContent] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const [genderState, setGenderState] = useState("");
  const [userTypeState, setUserTypeState] = useState("");
  const [experienceState, setExperienceState] = useState("");
  const [bookingslocation, setBookingsLocation] = useState();
  const [bookingsperiod, setBookingsPeriod] = useState();
  const [location1, setLocation1] = useState();
  const [locationPeriod, setLocationPeriod] = useState();
  const [ageRange, setAgeRange] = useState([0, 100]);
  const [sportType, setSportType] = useState([])

  const [saveFilterModal, setSaveFilterModal] = useState(false);

  // For Popup
  const [openLocationPopup, setOpenLocationPopup] = useState(null)
  const [openSavedsFiltersPopup, setOpenSavedFiltersPopup] = useState(null)

  const data = [
    {
      name: "Sun",
      uv: 15,
      pv: 0,
      amt: 24,
    },
    {
      name: "Mon",
      uv: 35,
      pv: 10,
      amt: 45,
    },
    {
      name: "Tue",
      uv: 36,
      pv: 20,
      amt: 45,
    },
    {
      name: "Wed",
      uv: 28,
      pv: 30,
      amt: 23,
    },
    {
      name: "Thu",
      uv: 41,
      pv: 40,
      amt: 34,
    },
    {
      name: "Fri",
      uv: 32,
      pv: 50,
      amt: 12,
    },
    {
      name: "Sat",
      uv: 8,
      pv: 60,
      amt: 29,
    },
  ];

  const summary = [
    {
      title: "Total bookings",
      img: totalBookings,
      price: "100,320",
    },
    {
      title: "Booking cancellations",
      img: BookingCancellations,
      price: "88",
    },
    {
      title: "Total users reached",
      img: UsersReached,
      price: "12,249",
    },
    {
      title: "Total users left",
      img: UsersLeft,
      price: "249",
    },
  ];

  const TopStates = [
    {
      state: "Florida",
      percent: 55,
    },
    {
      state: "Wyoming",
      percent: 20,
    },
    {
      state: "California",
      percent: 18,
    },
    {
      state: "Illinois",
      percent: 4,
    },
    {
      state: "Arizona",
      percent: 2,
    },
  ];

  const TopCities = [
    {
      state: "San Diego",
      percent: 55,
    },
    {
      state: "Miami",
      percent: 20,
    },
    {
      state: "Orlando",
      percent: 18,
    },
    {
      state: "Tampa",
      percent: 4,
    },
    {
      state: "Houston",
      percent: 2,
    },
  ];

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      // title: {
      //   display: true,
      //   text: "Chart.js Bar Chart",
      // },
    },
  };
  const labels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const sportTypesData = ['All', 'Tennis', 'Football', 'Soccer', 'Baseball', 'Golf', 'Skating', 'Basketball']

  const DrawerComp = () => (
    <Drawer
      open={isDrawerOpen}
      direction="right"
      enableOverlay={false}
      size={544}
    >
      <div className={`${classes.mainDrawerDiv}`}>
        <div className={classes.overflowScroll100Vh}>
          <div
            className={`${classes.dFlexJustifyContentEnd} ${classes.marginBottom15} ${classes.marginInline25}`}
          >
            <h1 style={{ ...Fonts.h4f26 }}>Filter</h1>
            <p
              style={{ ...Fonts.p2, cursor: "pointer" }}
              onClick={() => setIsDrawerOpen(false)}
            >
              Clear
            </p>
          </div>
          <Row className={classes.marginInline12}>
            <Col md={6}>
              <div className={classes.filterCard} style={{ border: `1px solid ${Colors.neutralShadesOfWhiteSmoke}` }}>
                <h1 className={classes.marginBottom15} style={{ ...Fonts.h5 }}>
                  Gender
                </h1>
                <Row>
                  <Col md={6}>
                    <Radio
                      value={genderState}
                      setValue={setGenderState}
                      label={"All"}
                    />
                  </Col>
                  <Col md={6}>
                    <Radio
                      value={genderState}
                      setValue={setGenderState}
                      label={"Female"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Radio
                      value={genderState}
                      setValue={setGenderState}
                      label={"Male"}
                    />
                  </Col>
                  <Col md={6}>
                    <Radio
                      value={genderState}
                      setValue={setGenderState}
                      label={"Others"}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={6}>
              <div className={classes.filterCard} style={{ border: `1px solid ${Colors.neutralShadesOfWhiteSmoke}` }}>
                <h1 className={classes.marginBottom15} style={{ ...Fonts.h5 }}>
                  User type
                </h1>
                <Row>
                  <Col md={6}>
                    <Radio
                      value={userTypeState}
                      setValue={setUserTypeState}
                      label={"All"}
                    />
                  </Col>
                  <Col md={6}>
                    <Radio
                      value={userTypeState}
                      setValue={setUserTypeState}
                      label={"Student"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Radio
                      value={userTypeState}
                      setValue={setUserTypeState}
                      label={"Coach"}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={12} className={classes.marginTop30}>
              <div className={classes.filterCard} style={{ border: `1px solid ${Colors.neutralShadesOfWhiteSmoke}` }}>
                <h1 className={classes.marginBottom15} style={{ ...Fonts.h5 }}>
                  Experience
                </h1>
                <Row>
                  <Col md={4}>
                    <Radio
                      value={experienceState}
                      setValue={setExperienceState}
                      label={"All"}
                    />
                  </Col>
                  <Col md={4}>
                    <Radio
                      value={experienceState}
                      setValue={setExperienceState}
                      label={"Beginner"}
                    />
                  </Col>
                  <Col md={4}>
                    <Radio
                      value={experienceState}
                      setValue={setExperienceState}
                      label={"Intermediate"}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <Radio
                      value={experienceState}
                      setValue={setExperienceState}
                      label={"Competitor"}
                    />
                  </Col>
                  <Col md={4}>
                    <Radio
                      value={experienceState}
                      setValue={setExperienceState}
                      label={"Advanced"}
                    />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md={12} className={classes.marginTop30}>
              <div className={classes.filterCard} style={{ border: `1px solid ${Colors.neutralShadesOfWhiteSmoke}` }}>
                <AverageAgeRangePicker
                  minAndMaxPrice={ageRange}
                  setMinAndMaxPrice={setAgeRange}
                  containerClass={classes.avgAgeRangeContainer}
                />
              </div>
            </Col>
            <Col md={12} className={classes.marginTop30}>
              <div className={classes.filterCard} style={{ border: `1px solid ${Colors.neutralShadesOfWhiteSmoke}` }}>
                <h1 className={classes.marginBottom15} style={{ ...Fonts.h5 }}>
                  Gender
                </h1>
                <Row>
                  {sportTypesData?.map(item => <Col md={4}><Checkbox label={item} setValue={setSportType} value={sportType} /> </Col>)}
                </Row>
              </div>
            </Col>

          </Row>
        </div>

        <hr style={{ margin: "0px 0 13px 0" }} />
        <div
          className={`${classes.dFlexJustifyContentSpaceBetweenAlignItemsCenter} ${classes.marginInline12}`}
        >
          <p style={{ ...Fonts.b2, lineHeight: '20px', color: Colors.neutralShadesOfNero }} onClick={() => setSaveFilterModal(true)}>
            Save Filter
          </p>
          <div
            className={classes.dFlexJustifyContentSpaceBetweenAlignItemsCenter}
          >
            <Button
              label={"Cancel"}
              primary={false}
              size={"Medium"}
              customStyle={{ width: "max-conntent", padding: '14px 36.5px', marginRight: '12px' }}
            />
            <Button
              label={"Apply"}
              primary={true}
              size={"Medium"}
              customStyle={{ width: "max-conntent", padding: '14px 40.5px' }}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );

  // For Range Color
  function decideColorOnPercentage(e) {
    if (e >= 55) {
      return Colors.mainBlue
    } else if (e >= 20 && e < 55) {
      return '#4d55e5b3'
    }
    else if (e >= 18 && e < 20) {
      return '#4c54e680'
    }
    else if (e >= 4 && e < 18) {
      return '#4c54e64d'
    }
    else {
      return '#4c54e633'
    }

  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  return (
    <>
      <style jsx>{`
        .rc-progress-line-trail {
          stroke-width: 4;
        }
        .rsm-geography {
          outline: none;
        }
      `}</style>
      <div className={classes.AdminTableMain}>
        {/* layout */}
        <Layout location1={location1} />
        <div className={classes.tableMain}>
          <Container fluid className={classes.container}>
            <h3
              className={classes.marginBlock24}
              style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
            >
              Dashboard
            </h3>
            <Row className="gx-1">
              {summary?.map((item, i) => {
                return (
                  <Col md={3}>
                    <div
                      className={[
                        classes.borderRadius10,
                        classes.AnalyticsMiddleSection,
                      ].join(" ")}
                      style={{
                        border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                      }}
                    >
                      <div className={classes.content}>
                        <ReactSVG
                          src={item.img}
                          className={[classes.AnalyticsMiddleSectionImg].join(
                            " "
                          )}
                        />

                        <div>
                          <h4
                            style={{
                              ...Fonts.h4,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            {item.price}
                          </h4>

                          <p
                            style={{
                              ...Fonts.otherSemiBold,
                              color: Colors.neutralShadesOfDimGray,
                            }}
                            className={[classes.mb4].join(" ")}
                          >
                            {item.title}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <h2
              className={classes.marginBlock25}
              style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
            >
              Bookings
            </h2>
            <Row className={classes.marginBottom20}>
              <Col md={6}>
                <Row>
                  <Col md={4}>
                    <DropDown
                      placeholder={""}
                      options={[
                        {
                          value: "bookings-reached",
                          label: "Bookings Reached",
                        },
                        {
                          value: "bookings-cancellations",
                          label: "Bookings Cancellations",
                        },
                      ]}
                      setter={setBookings}
                      state={bookings}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <ul className={classes.bookingsUl}>
                  <li onClick={(e) => setOpenLocationPopup(e.currentTarget)}>
                    <DropDown
                      placeholder={"Location"}
                      // options={[
                      //   {
                      //     value: "all",
                      //     label: "All",
                      //   },
                      // ]}
                      // setter={setBookingsLocation}
                      // state={bookingslocation}
                      customStyle={{ minWidth: "200px" }}
                    />
                  </li>
                  {/* Location Popup */}
                  <PopupRenderer setAnchorEl={setOpenLocationPopup} anchorEl={openLocationPopup}

                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <SearchWithList />
                  </PopupRenderer>
                  <li>
                    <DropDown
                      placeholder={"Period"}
                      options={[
                        {
                          value: "this-week",
                          label: "This Week",
                        },
                        {
                          value: "previous-week",
                          label: "Previous Week",
                        },
                      ]}
                      setter={setBookingsPeriod}
                      state={bookingsperiod}
                      customStyle={{ minWidth: "200px" }}
                    />
                  </li>
                  <li>
                    <Button
                      customStyle={{ width: "100%", padding: "12px 24px" }}
                      label={"Saved Filters"}
                      onClick={(e) => setOpenSavedFiltersPopup(e.currentTarget)}
                    />
                    {/* Saved Filters Popup */}
                    <PopupRenderer setAnchorEl={setOpenSavedFiltersPopup} anchorEl={openSavedsFiltersPopup}

                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <SavedFilters data={['NY, 20-30 years', 'San Diego, 20-30 years']} />
                    </PopupRenderer>

                  </li>
                  <li>
                    <Button
                      onClick={() => setIsDrawerOpen(true)}
                      size={"Medium"}
                      icon={AdminFilterIconBlack}
                    />
                  </li>
                </ul>
              </Col>
            </Row>

            <Row className={classes.graph}>
              <Col md={12}>
                <Bar
                  options={options}
                  data={{
                    labels,
                    datasets: [
                      {
                        // data: labels.map(() =>
                        //   faker.datatype.number({
                        //     min: 0,
                        //     max: 1000,
                        //   })
                        // ),
                        data: [100, 10, 5, 2, 20, 30, 45],
                        backgroundColor: "#D8D7F6",
                      },
                    ],
                  }}
                />
              </Col>
            </Row>
            <h2
              className={classes.marginBlock15}
              style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}
            >
              Location
            </h2>
            <Row className={classes.marginBottom20}>
              <Col md={6}>
                <Row>
                  <Col md={4}>
                    <DropDown
                      placeholder={"All"}
                      options={[
                        {
                          value: "Royal-Tennis-Court",
                          label: "Royal Tennis Court",
                        },
                        {
                          value: "Green-Tennis-Court",
                          label: "Green Tennis Court",
                        },
                      ]}
                      setter={setBookings}
                      state={bookings}
                    />
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <ul className={classes.locationsUl}>
                  <li>
                    <DropDown
                      placeholder={"Location"}
                      options={[
                        {
                          value: "all",
                          label: "All",
                        },
                      ]}
                      setter={setLocation1}
                      state={location1}
                      customStyle={{ minWidth: "200px" }}
                    />
                  </li>
                  <li>
                    <DropDown
                      placeholder={"Period"}
                      options={[
                        {
                          value: "this-week",
                          label: "This Week",
                        },
                        {
                          value: "previous-week",
                          label: "Previous Week",
                        },
                      ]}
                      setter={setLocationPeriod}
                      state={locationPeriod}
                      customStyle={{ minWidth: "200px" }}
                    />
                  </li>
                  <li>
                    <Button
                      customStyle={{ width: "100%", padding: "12px 24px" }}
                      label={"Saved Filters"}
                    />
                  </li>
                  <li>
                    <Button
                      onClick={() => setIsDrawerOpen(true)}
                      size={"Medium"}
                      icon={FilterIconBlack}
                    />
                  </li>
                </ul>
              </Col>
            </Row>
            <Row className="gx-2">
              <Col md={4}>
                <div className={classes.topStatesDescCard}>
                  <h1
                    className={`${classes.marginBottom15} ${classes.marginLeft14}`}
                    style={{ ...Fonts.h5 }}
                  >
                    Top States
                  </h1>
                  <div>
                    {TopStates?.map((item, index) => (
                      <Row
                        key={index}
                        className={`${classes.topStatesDescCardLine} ${classes.marginBottom10}`}
                      >
                        <Col md={4}>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfNero,
                            }}
                          >
                            {item.state}
                          </p>
                        </Col>
                        <Col md={5} xxl={6} className={classes.dflex}>
                          <Line
                            style={{ height: 12, borderRadius: 6 }}
                            percent={item.percent}
                            strokeWidth={4}
                            strokeColor={decideColorOnPercentage(item.percent)}
                          />
                        </Col>
                        <Col md={3} xxl={2}>
                          <p
                            style={{
                              ...Fonts.p1,
                              color: Colors.neutralShadesOfDimGray,
                            }}
                          >
                            {item.percent}%
                          </p>
                        </Col>
                      </Row>
                    ))}
                  </div>

                  <h1
                    className={`${classes.marginBottom15} ${classes.marginTop25} ${classes.marginLeft14}`}
                    style={{ ...Fonts.h5 }}
                  >
                    Top Cities
                  </h1>
                  {TopCities?.map((item, index) => (
                    <Row
                      key={index}
                      className={`${classes.topStatesDescCardLine} ${classes.marginBottom10} `}
                    >
                      <Col md={4} xxl={4}>
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          {item.state}
                        </p>
                      </Col>
                      <Col md={5} xxl={6} className={classes.dflex}>
                        <Line
                          style={{ height: 12, borderRadius: 6 }}
                          percent={item.percent}
                          strokeWidth={4}
                          strokeColor={decideColorOnPercentage(item.percent)}
                        />
                      </Col>
                      <Col md={3} xxl={2}>
                        <p
                          style={{
                            ...Fonts.p1,
                            color: Colors.neutralShadesOfDimGray,
                          }}
                        >
                          {item.percent}%
                        </p>
                      </Col>
                    </Row>
                  ))}
                </div>
              </Col>
              <Col md={8}>
                <div className={classes.topStatesDescCard}>
                  <UsaMapCharts setTooltipContent={setContent} />
                  <ReactTooltip className={classes.tooltip}>
                    <h6
                      style={{ ...Fonts.h9, color: Colors.mainShadeOfRed }}
                      className={classes.mb12}
                    >
                      {content?.state}
                    </h6>
                    <p
                      style={{
                        ...Fonts.p1,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                      className={classes.mb12}
                    >
                      Students:&nbsp;
                      <span
                        style={{
                          ...Fonts.h7,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {content?.students}
                      </span>
                    </p>
                    <p
                      style={{
                        ...Fonts.p1,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                    >
                      Coaches:&nbsp;
                      <span
                        style={{
                          ...Fonts.h7,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {content?.coaches}
                      </span>
                    </p>
                  </ReactTooltip>
                </div>
              </Col>
            </Row>

            {/* content */}
          </Container>
        </div>
      </div>
      {/* modal */}

      <DrawerComp />

      <SaveFilterModal show={saveFilterModal} setShow={setSaveFilterModal} />
    </>
  );
};

export default AdminDashboard;
